module.exports = __webpack_public_path__ + "assets/images/delivered.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/delivered.png
// module id = 400
// module chunks = 1